const STORAGE_KEY = "mst:cameraMappingSelectionByBranch";

interface StoredSelection {
  floorPlanId: number | null;
  cameraId: number | null;
}

type StoredMap = Record<string, StoredSelection>;

function readMap(): StoredMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as StoredMap) : {};
  } catch {
    return {};
  }
}

export function readMappingSelection(branchUid: string): StoredSelection | undefined {
  return readMap()[branchUid];
}

export function writeMappingSelection(
  branchUid: string,
  selection: StoredSelection,
) {
  try {
    const map = readMap();
    map[branchUid] = selection;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // localStorage 접근 실패는 무시 (시크릿 모드/쿼터 초과 등)
  }
}
